import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';
import { Link } from 'react-router-dom';

const ByExp = props => {
  if (props.requestState.inProgress) {
    return <MediumPreLoader />;
  }
  return (
    <div className="table-responsive">
      <table className="table table-sortible table-hover m-b-0">
        <thead>
          <tr>
            <th className="text-center">{t('Место')}</th>
            <th className="text-center">{t('Пользователь')}</th>
            <th className="text-center">{t('Очков опыта')}</th>
          </tr>
        </thead>
        <tbody>
          {props.itemsIds.map((itemId, index) => {
            const item = props.selectItemById(itemId);
            return (
              <tr key={`TopUserItemByExp${itemId}`}>
                <td className="text-center">{index + 1}</td>
                <td className="text-center">
                  <Link to={`/users/profile/${item.id}`}>
                    <div className="media media_inline-table">
                      <div className="media-left">
                        <img
                          alt=""
                          className="media-object avatar avatar-xxs"
                          src={item.avatarPath}
                        />
                      </div>
                      <div className="media-body media-middle">
                        <div
                          className="text-overflow text-overflow_sm"
                          title={item.username}
                        >
                          {item.username}
                        </div>
                      </div>
                    </div>
                  </Link>
                </td>
                <td className="text-center">
                  {t('{sum} балл.', { sum: item.total })}
                </td>
              </tr>
            );
          })}
          {props.itemsIds.length === 0 ? (
            <tr>
              <td className="text-center" colSpan="3">
                {t('Пользователи не найдены')} :-(
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
};

ByExp.propTypes = {
  // CONNECT STATES
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired
};

export default ByExp;



// WEBPACK FOOTER //
// ./src/components/TopUsers/ByExp/ByExp.js